import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import style from "./styles"
let layersMap = {layers:[]};

var realestateLayer = new VectorLayer({
    name:"realestate",
    source: new VectorSource(),
    style: style.realestateStyleFunction(false),
    selectStyle: style.realestateStyleFunction(true),
    query:""
});
layersMap["realestateLayer"]=realestateLayer;
layersMap["layers"].push(realestateLayer);
layersMap.selection = {
    feature:null,
    point:null,
    id:null
}
layersMap.highlite = {
    feature:null
}
layersMap.query = "";



export default layersMap;